import React from 'react';
import { IconBlock, Icon } from 'anf-core-react';
import { TmntText } from '../../Common';
import { stepTitleProps } from './props';

export default function StepTitle({ stepNumber, title }) {
  // Cancelled state: show cancel icon and label only
  if (title.value === 'cancelled') {
    return (
      <div className="rne-nextstep-title" data-state="cancelled">
        <IconBlock
          orientation="horizontal"
          icon={<Icon icon="cancel" size="m" />}
        >
          <TmntText tmnt={title?.label} />
        </IconBlock>
      </div>
    );
  }

  const hasStepNumber = title.value !== 'cancelled' && title.value !== 'complete';

  return (
    <div className="rne-nextstep-title" data-state={title.value}>
      <IconBlock
        orientation="horizontal"
        icon={(
          <span
            className="step"
            data-state={title.value}
            data-testid={`step-title-${stepNumber}`}
          >
            <span className="step-inner">
              {hasStepNumber && stepNumber}
            </span>
          </span>
      )}
      >
        <TmntText tmnt={title?.label} />
      </IconBlock>
    </div>
  );
}

StepTitle.propTypes = stepTitleProps;
